import { render, staticRenderFns } from "./CreateApprovers.vue?vue&type=template&id=c699d48a"
import script from "./CreateApprovers.vue?vue&type=script&lang=js"
export * from "./CreateApprovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports